import * as React from 'react'
import { DayPicker } from 'react-day-picker'

import { Icon } from '#app/ui/components/custom/icon'
import { buttonVariants } from '#app/ui/components/shadcnui/button.js'
import { cn } from '#app/utils/tailwind-merge.ts'

export type CalendarProps = React.ComponentProps<typeof DayPicker>

function Calendar({
	className,
	classNames,
	showOutsideDays = true,
	...props
}: CalendarProps) {
	return (
		<DayPicker
			showOutsideDays={showOutsideDays}
			className={cn('p-3', className)}
			classNames={{
				months: 'flex flex-col sm:flex-row space-y-4 sm:space-x-4 sm:space-y-0',
				month: 'space-y-4',
				caption: 'flex justify-center pt-1 relative items-center',
				caption_label: 'text-sm font-medium',
				nav: 'space-x-1 flex items-center',
				nav_button: cn(
					buttonVariants({ variant: 'outline' }),
					'h-7 w-7 bg-transparent p-0 opacity-50 hover:opacity-100',
				),
				nav_button_previous: 'absolute left-1',
				nav_button_next: 'absolute right-1',
				table: 'w-full border-collapse space-y-1',
				head_row: 'flex',
				head_cell: 'text-muted-600 rounded-md w-9 font-normal text-[0.8rem]',
				row: 'flex w-full mt-2',
				cell: 'h-9 w-9 text-center text-sm p-0 relative [&:has([aria-selected].day-range-end)]:rounded-r-md [&:has([aria-selected].day-outside)]:bg-muted-100 [&:has([aria-selected])]:bg-muted-200 first:[&:has([aria-selected])]:rounded-l-md last:[&:has([aria-selected])]:rounded-r-md focus-within:relative focus-within:z-20',
				day: cn(
					buttonVariants({ variant: 'ghost' }),
					'h-9 w-9 p-0 font-normal aria-selected:opacity-100',
				),
				day_range_end: 'day-range-end',
				day_selected:
					'bg-muted-900 text-muted-50 hover:bg-muted-900 hover:text-muted-50 focus:bg-muted-900 focus:text-muted-50',
				day_today: 'bg-muted-300 text-muted-50',
				day_outside:
					'text-muted-300 aria-selected:bg-muted-300 aria-selected:text-muted-100',
				day_disabled: 'text-muted-400',
				day_range_middle:
					'aria-selected:bg-muted-200 aria-selected:text-muted-400',
				day_hidden: 'invisible',
				...classNames,
			}}
			components={{
				IconLeft: () => <Icon name="chevron-left" className="h-4 w-4" />,
				IconRight: () => <Icon name="chevron-right" className="h-4 w-4" />,
			}}
			{...props}
		/>
	)
}
Calendar.displayName = 'Calendar'

export { Calendar }
